<div class="flex flex-col px-16">
  <div class="title-container mx-32">
    <h3 class="mb-32">Select Loadcells to add to Pressure Report</h3>
  </div>
  <div class="flex flex-col list-container">
    <div
      *ngFor="let cell of loadcells"
      class="flex flex-row list-item flex-wrap justify-between"
    >
      <mat-checkbox
        class="center-text w-50"
        (change)="toggleIncludeCell(cell, $event)"
        [disabled]="cell == data?.loadcellId"
        [checked]="isIncluded(cell)"
      >
        <span class="text-black">{{ cell }}</span>
      </mat-checkbox>
    </div>
  </div>

  <div class="flex flex-row mt-16 mb-16 dialog-button-row">
    <button
      mat-stroked-button
      color="accent"
      type="button"
      (click)="dialogRef.close(false)"
    >
      Cancel
    </button>
    <button mat-flat-button color="primary" (click)="close(true)">
      {{ "Continue" }}
    </button>
  </div>
</div>
